














import {
  createComponent,
  inject,
  onMounted,
  computed,
  onUpdated
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import Menu from "@/components/templates/Menu/Menu.vue";
import Footer from "@/components/molecules/Footer.vue";
export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const menu = company.menu;
    const getWindowWidth = company.getWindowWidth
    const getWindowHeight = company.getWindowHeight
    onMounted(() => {
      window.addEventListener("resize", getWindowWidth);
      window.addEventListener("resize", getWindowHeight);

      //Init
      getWindowWidth();
      getWindowHeight();
    });
    onUpdated(() =>{
      company.refreshToken()
    })

    return {
      menu
    };
  },
  components: {
    Menu,
     Footer
  },
})
